module.exports = __webpack_public_path__ + "img/1abc3d0.png";